import React from 'react';
import { IconButton, Typography, Box, CircularProgress } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { brandColors } from '../../theme';

interface LikeButtonProps {
  likeCount: number;
  userHasLiked: boolean;
  isLoading?: boolean;
  onLike: () => void;
}

const LikeButton: React.FC<LikeButtonProps> = ({
  likeCount,
  userHasLiked,
  isLoading = false,
  onLike,
}) => {
  const isDisabled = isLoading || userHasLiked;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <IconButton
        onClick={onLike}
        disabled={isDisabled}
        size="small"
        aria-label={userHasLiked ? 'You already liked this idea' : 'Like this idea'}
        sx={{
          color: userHasLiked ? brandColors.blue : brandColors.mediumGray,
          '&:hover': {
            color: brandColors.blue,
            backgroundColor: `${brandColors.blue}10`,
          },
          '&.Mui-disabled': {
            color: userHasLiked ? brandColors.blue : 'inherit',
          },
        }}
      >
        {isLoading ? (
          <CircularProgress size={18} />
        ) : userHasLiked ? (
          <ThumbUpIcon fontSize="small" />
        ) : (
          <ThumbUpOutlinedIcon fontSize="small" />
        )}
      </IconButton>
      <Typography
        variant="body2"
        sx={{
          color: userHasLiked ? brandColors.blue : brandColors.mediumGray,
          fontWeight: userHasLiked ? 600 : 400,
          minWidth: 16,
        }}
      >
        {likeCount}
      </Typography>
    </Box>
  );
};

export default LikeButton;
